'use strict';

function controller (shadowSettingsService) {
    const ctrl = this;
    ctrl.name = 'dealerPhoneCta';

    ctrl.firePhoneReporting = function() {

        const alsWebToId = (stockType) => {
            if (stockType === "Used" || stockType === "CPO") {
                return 2412;
            } else if (stockType === "New") {
                return 2411;
            }
        };

        const alsImpression = {
            pageToId: alsWebToId(ctrl.stockTypeCode)
        };
        alsImpression.publicDeviceId = CARS.digitalData ? CARS.digitalData.user.profileInfo.publicDeviceId : 0;
        alsImpression.listingId = ctrl.listingId;
        alsImpression.stockTypeCode = ctrl.stockTypeCode;
        alsImpression.sellerId = ctrl.sellerId;

        sendAlsImpression('POST', '/ajax/a773a9c189a3ff4/1.0/impression', JSON.stringify(alsImpression), "application/json").then(data => {}).catch((e) => console.log("error", e));
        shadowSettingsService.phoneReporting();
    };

    function sendAlsImpression(method, url, data = "", header = "") {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url);
            xhr.setRequestHeader("Content-Type", header);
            xhr.onload = function () {
                if (xhr.status === 200) {
                    resolve(xhr.response);
                } else {
                    reject(Error(xhr.statusText));
                }
            };
            xhr.onerror = reject;
            xhr.send(data);
        });
    }
}

controller.$inject = ['shadowSettingsService'];

export default controller;
